import { Space } from '../../space';
import Tag from '../Tag';

export type TagItem = {
  id?: string;
  name: string;
};

type P = {
  tags: TagItem[];
};

const TagList = ({ tags }: P) => (
  <Space size={['xs', 'xs']} wrap>
    {tags.map((tagItem) => (
      <Tag key={tagItem.id ?? tagItem.name}>{tagItem.name}</Tag>
    ))}
  </Space>
);

export default TagList;
